<mat-table [dataSource]="dataSub" matSort aria-label="Meeting Occurance List">
  <!-- column definitions -->
  <ng-container matColumnDef="{{ column }}" *ngFor="let column of columns; index as i" class="header-cell">
    <!-- @if (columnConfig[i].sort) { -->
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{ columnConfig[i].label }}</mat-header-cell>
    <!-- } -->
    <!--<th mat-header-cell *matHeaderCellDef [disabled]="!columnConfig[i].sort">{{ columnConfig[i].label }}</th>-->
    <mat-cell *matCellDef="let cell; index as j" [class.is-linkable]="columnConfig[i].linkable">
      @if (columnConfig[i].key === 'parentMeetingOccurrenceKey') {
        <ng-container>
          <a href="javascript: void(0);" (click)="viewAppointment(cell.parentMeetingOccurrenceKey, cell.parentMeetingKey)">
            {{ cell.parentMeetingOccurrenceKey }}
          </a>
        </ng-container>
      }

      @if (columnConfig[i].key === 'startISOFormatted' || columnConfig[i].key === 'endISOFormatted') {
        <ng-container>
          {{ cell[column] }}
        </ng-container>
      }

      @if (columnConfig[i].key === 'clientName') {
        <ng-container>
          <a href="javascript: void(0);" (click)="viewClient(cell.parentClientKey, cell.parentCaseKey)">
            {{ cell.clientName }}
          </a>
        </ng-container>
      }

      @if (columnConfig[i].key !== 'startISOFormatted' && columnConfig[i].key !== 'endISOFormatted' 
           && columnConfig[i].key !== 'parentMeetingOccurrenceKey' && columnConfig[i].key !== 'clientName') {
        <ng-container>
          {{ cell[column] }}
        </ng-container>
      }
    </mat-cell>
  </ng-container>

  <!-- Header Row-->
  <mat-header-row *matHeaderRowDef="columns"></mat-header-row>

  <!-- Select Record -->
  <mat-row *matRowDef="let cell; columns: columns"></mat-row>
</mat-table>

<!-- No data found -->
<ng-container *transloco="let t;">
  @if (isReady && resultCount < 1) {
    <ng-container>
      <div class="noresult">
        <div class="center"><center><div style="margin-block: 3%">
                  {{ t('NoResultsFound') }}
                </div></center></div>
      </div>
    </ng-container>
  }
</ng-container>